/**
 * Opciones de proveedor para autocompletar: razón social y, en la segunda línea, el CUIT.
 * @param {Array<Object>} providers Entidades proveedoras.
 * @returns {Array<{value: string, label: string, secondary: string}>}
 */
export const toProviderOptions = (providers = []) =>
  providers.map((provider) => ({
    value: provider.uuid,
    label:
      provider.legal_business_name?.trim() || provider.company?.trim() || provider.cuit || '',
    secondary: provider.cuit ? `CUIT ${provider.cuit}` : '',
  }));
